import React, { useState } from 'react';
import { View, Text, TouchableOpacity, Alert, FlatList } from 'react-native';
import { oTests } from '../olonkho-tests';
import { oStyles } from '../olonkho-styles';
import { Constants } from '../olonkho-constants';
import { OTextInput, OAnswerButton } from '../olonkho-fw';

export default function Tests({ navigation }) {
    const [test, setTest] = useState(0);
    const [isAnswer, setIsAnswer] = useState(false);
    const [answer, setAnswer] = useState(-1);
    const [correctCount, setCorrectCount] = useState(0);
    const [correctDescCount, setCorrectDescCount] = useState(0);

    function ShowTestResult() {
        let tdesc = oTests.filter(t => t.type == Constants.TEST_ANSWER);
        let totalCount = 0;
        for (let i = 0; i < tdesc.length; i++) {
            totalCount += tdesc[i].exercises.length;
        }
        Alert.alert(
            "Тест завершен!", 
            "Правильных тестов: " + correctCount.toString() + " из " + oTests.filter(t => t.type == Constants.TEST_VARIANT).length.toString() + "\n" + 
            "Правильных описаний: " + correctDescCount.toString() + " из " + totalCount.toString(),
            [{
                text: "OK",
                onPress: () => { navigation.navigate("Lessons"); },
                style: "default"
            }]
        );
    }
    
    if (oTests[test].type == Constants.TEST_VARIANT) {
        return (
            <View style={ { flex: 1 } }>
                <View>
                    <Text style={ oStyles.test_title }>
                        { "Вопрос: " + (test + 1).toString() + "/" + oTests.length.toString() }
                    </Text>
                    <Text style={ oStyles.test_text }>{ oTests[test].text }</Text>
                </View>
                <FlatList
                    data={ oTests[test].variants }
                    renderItem={ (item) => {
                        return (
                            <TouchableOpacity 
                                style={ [oStyles.test_button, isAnswer ? (item.index == answer) ? 
                                ((answer == oTests[test].correct) ? {
                                    borderColor: 'green',
                                    backgroundColor: 'lightgreen'
                                } : {
                                    borderColor: 'red',
                                    backgroundColor: 'lightcoral'
                                }) : 
                                ((item.index == oTests[test].correct) ? {
                                    borderColor: 'green',
                                    backgroundColor: 'lightgreen'
                                } : {}) : {}
                                ] } 
                                onPress={ () => {
                                    if (item.index == oTests[test].correct) {
                                        setCorrectCount(correctCount + 1);
                                    }
                                    setAnswer(item.index);
                                    setIsAnswer(true);
                                } } 
                                disabled={ isAnswer }>
                                <Text style={ oStyles.test_button_text }>{ item.item }</Text>
                            </TouchableOpacity>
                        );
                    }}
                    keyExtractor={ (item) => { return item; } }
                />
                <View style={ !isAnswer ? { display: 'none', alignSelf: 'flex-end'} : {} }>
                    <OAnswerButton
                        title={ (test < oTests.length - 1) ? "Следующий вопрос" : "Завершить тест" }
                        onPress={ () => {
                            if (test < oTests.length - 1) {
                                setAnswer(-1);
                                setIsAnswer(false);
                                setTest(test + 1);
                            }
                            else {
                                ShowTestResult();
                            }
                        } }    
                    />
                </View>
            </View>
        );
    }
    else {
        return (
            <View style={ { flex: 1 } }>
                <View>
                    <Text style={ oStyles.test_title }>
                        { "Вопрос: " + (test + 1).toString() + "/" + oTests.length.toString() }
                    </Text>
                    <Text style={ oStyles.test_text }>{ oTests[test].text }</Text>
                </View>
                <FlatList 
                    data={ oTests[test].exercises }
                    renderItem={ (item) => {
                        return (
                            <View>
                                <Text style={ oStyles.test_question }>{ item.item.question }</Text>
                                <OTextInput
                                    isAnswer={ isAnswer }
                                    answers={ item.item.answers }
                                    afterAnswer={ (result) => {
                                        if (result.result) {
                                            setCorrectDescCount(correctDescCount + 1);
                                        }
                                    }}
                                />
                                <Text style={ [ oStyles.test_question, !isAnswer ? { display: 'none' } : {} ] }>
                                    { "Ответ: " + item.item.answer }
                                </Text>
                            </View>
                        );
                    } }
                    keyExtractor={ (item) => { return item.question } }
                />
                <View style={ isAnswer ? { display: 'none' } : {} }>
                    <OAnswerButton 
                        title="Проверить"
                        onPress={ () => {
                            setIsAnswer(true);
                        } }
                    />
                </View>
                <View style={ !isAnswer ? { display: 'none', alignSelf: 'flex-end'} : {} }>
                    <OAnswerButton
                        title={ (test < oTests.length - 1) ? "Следующий вопрос" : "Завершить тест" }
                        onPress={ () => {
                            if (test < oTests.length - 1) {
                                setAnswer(-1);
                                setIsAnswer(false);
                                setTest(test + 1);
                            }
                            else {
                                ShowTestResult();
                            }
                        } }    
                    />
                </View>
            </View>
        );
    }
}